import React, { useState } from 'react';
import { Alert, Chip, AlertTitle, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import { createPortal } from 'react-dom';
import useScreenSize from '../../../utils/useScreenSize';

const IsReadOnlyChip = () => {
  const { t } = useTranslation();
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const { isXsScreen: isMobile } = useScreenSize();

  const ReadOnlyAlert = () => {
    const desktopAlertStyle = {
      position: 'absolute',
      top: `-${spaces.xs}`,
      right: spaces.md,
      width: 372,
    };
  
    const mobileAlertStyle = {
      position: 'absolute',
      top: `-${spaces.xxxs}`,
      left: spaces.md,
      right: spaces.md,
    };

    return (
      <Alert 
        severity='info'
        data-testid='is-read-only-alert'
        sx={isMobile ? mobileAlertStyle : desktopAlertStyle}
      >
        <AlertTitle sx={{ color: palette.info.dark }} >{t('Read Only Content')}</AlertTitle>
        <Typography variant='body2' color={palette.info.dark}>
          {t('Due to licensing restrictions, you can only read this content online, but you cannot download it.')}
        </Typography>
      </Alert>
    );
  };

  const ReadOnlyAlertWrapper = () => {
    const container = document.querySelector('[data-testid="new-reader-content-container"]');
    return container ?
      createPortal(<ReadOnlyAlert />, container) : null;
  };
  
  return (
    <Box sx={{ position: 'relative' }}>
      <Chip
        data-testid='is-read-only-chip'
        label={t('Read only')}
        onClick={() => setIsAlertOpen(true)}
        onMouseEnter={() => setIsAlertOpen(true)}
        onMouseLeave={() => setIsAlertOpen(false)}
      />
      { isAlertOpen && <ReadOnlyAlertWrapper /> }
    </Box>
  );
};

export default IsReadOnlyChip;
